// extracted by mini-css-extract-plugin
export default {"Box":"milestone-module__Box__CREM0rt"};